import { pickBy } from './common';
import { parse, stringify } from './urlHelpers';

/**
 * Topbar modal flags live in the query string but are UI-only.
 * Changing them must not scroll-to-top or re-run route `loadData` (e.g. SearchPage listings).
 */
export const UI_ONLY_SEARCH_PARAMS = ['mobilemenu', 'mobilesearch'];

/**
 * Drop hamburger / mobile-search chrome flags from a parsed query object.
 * Filter edits must not round-trip these or the overlay reopens.
 *
 * @param {Object} params parsed query params
 * @returns {Object}
 */
export const omitUiOnlySearchParams = (params = {}) =>
  pickBy(params, (_value, key) => !UI_ONLY_SEARCH_PARAMS.includes(key));

/**
 * @param {string|null|undefined} search location.search
 * @returns {string} canonical query string without UI-only params (no leading '?')
 */
export const searchWithoutUiOnlyParams = search => {
  const params = parse(search || '');
  const cleaned = pickBy(params, (_value, key) => !UI_ONLY_SEARCH_PARAMS.includes(key));
  return stringify(cleaned);
};

/**
 * When true, an in-app navigation that only changes search/hash should skip
 * scroll-to-top and route `loadData` (e.g. ProfilePage tabs, topbar mobile modals).
 *
 * @param {{ pathname?: string, search?: string }|null|undefined} prevLocation
 * @param {{ pathname?: string, search?: string }|null|undefined} nextLocation
 * @param {{ keepScrollAndDataOnSearchChange?: boolean }|null|undefined} route
 * @returns {boolean}
 */
export const shouldKeepScrollAndDataOnSearchChange = (prevLocation, nextLocation, route) => {
  if (!prevLocation || !nextLocation || prevLocation.pathname !== nextLocation.pathname) {
    return false;
  }
  if (route?.keepScrollAndDataOnSearchChange === true) {
    return true;
  }
  // Hamburger / mobile search toggles only change UI-only query flags.
  return (
    searchWithoutUiOnlyParams(prevLocation.search) ===
    searchWithoutUiOnlyParams(nextLocation.search)
  );
};
